if (!window.mpsFeaturedProductsInitialized) {
  window.mpsFeaturedProductsInitialized = true;

  document
    .querySelectorAll('.mps-featured-layout__carousel .product-grid--carousel')
    .forEach((carousel) => {
      const items = Array.from(carousel.querySelectorAll('.slider__item'));

      if (!items.length) return;

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          theme.manuallyLoadImages(entry.target);
          observer.unobserve(entry.target);
        });
      }, {
        root: null,
        rootMargin: '0px 250px 0px 250px'
      });

      items.forEach((item, index) => {
        if (index >= 3) {
          observer.observe(item);
        }
      });

      // Hydrate secondary images only when the customer
      // actually interacts with a product card.
      carousel.querySelectorAll('product-block').forEach((card) => {
        const hydrateSecondaryImages = () => {
          card.querySelectorAll('.product-block__image--secondary').forEach((image) => {
            theme.manuallyLoadImages(image);
          });

          card.removeEventListener('mouseenter', hydrateSecondaryImages);
          card.removeEventListener('touchstart', hydrateSecondaryImages);
          card.removeEventListener('focusin', hydrateSecondaryImages);
        };

        card.addEventListener('mouseenter', hydrateSecondaryImages);
        card.addEventListener('touchstart', hydrateSecondaryImages, { passive: true });
        card.addEventListener('focusin', hydrateSecondaryImages);
      });
    });
}